export default class AjaxEntity {

	/**
	 * @abstract
	 * @returns {string}
	 */
	static get NAME() {
		throw new Error('You have to implement the static getter "NAME", for each entity!');
	}

	#name;
	#config;
	#endpoints;

	constructor() {
		/** @type {any} */
		const ctr = this.constructor;
		this.#name = ctr.NAME.toLowerCase();
	}

	get config() {

		if (!this.#config) {
			this.#config = mpro.config[this.#name];
		}

		return this.#config;
	}

	get endpoints() {

		if (!this.#endpoints) {
			this.#endpoints = this.config.endpoints;
		}

		return this.#endpoints;
	}
}
